<template>
    <div class="products-component__inner">
        <ul class="filter">
            <li class="filter__item" v-if="!hasPreselectedType">
                <span>{{ dictionary.ProductsShowFamilyLabel }}</span>
                <label class="switch">
                    <input v-model="type" false-value="families" true-value="variants" type="checkbox">
                    <span class="slider round"></span>
                </label>
                <span>{{ dictionary.ProductsShowVariantLabel }}</span>

            </li>
            <li class="filter__item" v-if="categories.length > 0 && !hasPreselectedCategory">
                <label for="categoryFilter" class="sr-only">{{ dictionary.ProductsCategorySelectLabel }}</label>
                <select id="categoryFilter" v-model="category" :disabled="isLoading">
                    <option value="All">{{ dictionary.ProductsCategorySelectLabel }}</option>
                    <option v-for="categoryItem in categories" :key="categoryItem.Key" :value="categoryItem.Key">{{
                        categoryItem.Name
                    }}
                    </option>
                </select>
            </li>
            <li class="filter__item" v-if="functionalities.length > 0">
                <label for="functionalityFilter" class="sr-only">{{ dictionary.ProductsFunctionalitySelectLabel
                }}</label>
                <select id="functionalityFilter" v-model="functionality" :disabled="isLoading">
                    <option value="All">{{ dictionary.ProductsFunctionalitySelectLabel }}</option>
                    <option v-for="functionalityItem in functionalities" :key="functionalityItem.Key"
                        :value="functionalityItem.Key">{{
                            functionalityItem.Name
                        }}</option>
                </select>
            </li>
            <li class="filter__item" v-if="spaces.length > 0">
                <label for="spaceFilter" class="sr-only">{{ dictionary.ProductsSpaceSelectLabel }}</label>
                <select id="spaceFilter" v-model="space" :disabled="isLoading">
                    <option value="All">{{ dictionary.ProductsSpaceSelectLabel }}</option>
                    <option v-for="spaceItem in spaces" :key="spaceItem.Key" :value="spaceItem.Key">{{ spaceItem.Name }}
                    </option>
                </select>
            </li>
            <li class="filter__item" v-if="hasFilterApplied">
                <button type="button" @click="resetFilter">{{ dictionary.ProductsResetFilter }}</button>
            </li>
            <li class="filter__item filter__item--text">
                {{ dictionary.ProductsListCounterPretext }} {{ loadedProducts }} {{
                    dictionary.ProductsListCounterPosttext }}
            </li>
        </ul>
        <div class="products-component__hr"></div>
        <ul class="products-component__list">
            <li class="products-component__list-item" v-for="product in products" :key="product.Url">
                <a class="product-card" :href="product.Url">
                    <div class="product-card__image">

                        <div v-if="product.HasImage" class="product-card__image-primary"
                            :class="{ 'product-card__image-primary--cover': product.ImageCoversCard }">
                            <ResponsiveImage :imageModel="product.ImageForVue" />
                        </div>
                        <div v-if="product.HasImage" class="product-card__image-secondary"
                            :class="{ 'product-card__image-secondary--cover': product.AlternativeImageCoversCard }">
                            <ResponsiveImage :imageModel="product.AltImageForVue" />
                        </div>

                    </div>
                    <p class="product-card__name">{{ product.Name }}</p>

                    <p class="product-card__description">{{ product.Description }}</p>

                </a>
            </li>

        </ul>
        <div class="products-component__footer">
            <div class="products-component__no-products" v-show="!products.length && !isLoading">
                {{ dictionary.ProductsNoResults }}
            </div>
            <div class="products-component__counter">{{ dictionary.ProductsListCounterPretext }} {{ loadedProducts }} /
                {{ totalProducts }} {{ dictionary.ProductsListCounterPosttext }}</div>
            <div class="products-component__load-more" v-show="hasMoreProducts">
                <a @click="getNextPage" :disabled="isLoading">{{
                    dictionary.ProductsLoadMore
                }}</a>
            </div>
        </div>
    </div>
</template>

<script>
import { nextTick } from 'vue'
import { bindRoute } from "./mixins/bindroute.js";
import ResponsiveImage from "./components/responsiveImage.vue";


const serviceUrl = "/umbraco/api/productsapi/getproducts",
    defaultType = "families",
    defaultFunctionality = "All",
    defaultSpace = "All",
    defaultCategory = "All";
export default {
    name: "products",
    components: {
        ResponsiveImage
    },
    data() {
        return {
            dictionary: [],
            categories: [],
            functionalities: [],
            spaces: [],
            products: [],
            pageSize: 8,
            // page: 1,
            totalProducts: 0,
            loadedProducts: 0,
            isLoading: false,
            hasLoadedInitials: false,
            productsNodeId: 0,
            preselectedCategory: defaultCategory,
            hasPreselectedCategory: false,
            preselectedType: defaultType,
            hasPreselectedType: false,
            defaultCategory: defaultCategory,
            isResetting: false,
            metaCategories: null
        };
    },
    mixins: [
        bindRoute({
            category: defaultCategory,
            functionality: defaultFunctionality,
            space: defaultSpace,
            type: defaultType,
            page: 1
        }),
    ],
    watch: {
        page: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal, false, true);
            }
        },
        functionality: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal, true, false);
            }
        },
        space: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal, true, false);
            }
        },
        category: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal, true, false);
            }
        },
        type: {
            handler(oldVal, newVal) {
                this.handleFilterPropertyChange(oldVal, newVal, true, false)
            }
        }
    },
    mounted() {
        this.productsNodeId = this.$parent.productsNodeId;
        this.metaCategories = this.$parent.metaCategories;

        const preselectedCategory = this.$parent.preselectedCategory.toLowerCase();
        if (preselectedCategory != "") {
            this.hasPreselectedCategory = true;
            this.preselectedCategory = preselectedCategory;
            this.category = preselectedCategory;
        }
        const preselectedType = this.$parent.preselectedType.toLowerCase();
        if (preselectedType != "") {
            this.hasPreselectedType = true;
            this.preselectedType = preselectedType;
            this.type = preselectedType;
        }

        this.$router.isReady().then(() => {
            this.getInitialProducts();
        }).catch(error => {
            console.log(error);
        });
    },
    methods: {
        handleFilterPropertyChange(oldVal, newVal, resetPage = false, append = false) {
            if (oldVal !== newVal) {
                if (this.hasLoadedInitials && !this.isResetting) {
                    this.filterChanged(resetPage, append);
                }
            }
        },
        getProducts(amountToSkip, pageSize, append = false) {
            const vm = this,
                languageCode = document.querySelector("html").getAttribute("lang");
            vm.toggleSpinner(true);
            var object = {
                productsNodeId: vm.productsNodeId,
                languageCode: languageCode,
                amountToSkip: amountToSkip,
                pageSize: pageSize,
            };

            if (vm.preselectedType != defaultType) {
                object.type = vm.preselectedType;
            } else if (vm.type != defaultType) {
                object.type = vm.type;
            }
            if (vm.preselectedCategory != defaultCategory) {
                object.category = vm.preselectedCategory;
            } else if (vm.category != defaultCategory) {
                object.category = vm.category;
            }

            if (vm.functionality != defaultFunctionality) {
                object.functionality = vm.functionality;
            }

            if (vm.space != defaultSpace) {
                object.space = vm.space;
            }

            if (vm.metaCategories != null) {
                object.metaCategories = vm.metaCategories;
            }

            fetch(serviceUrl + "?" + new URLSearchParams(object))
                .then((response) => response.json())
                .then((data) => {

                    if (append) {
                        vm.products.push(...data.Items);
                        vm.loadedProducts += data.Items.length;
                    } else {
                        vm.products = data.Items;
                        vm.loadedProducts = data.Items.length;
                    }
                    vm.totalProducts = data.TotalItems;

                    vm.dictionary = data.Dictionary;
                    vm.categories = data.Facets.Categories;
                    vm.functionalities = data.Facets.Functionalities;
                    vm.spaces = data.Facets.Spaces;

                    nextTick(() => {
                        vm.hasLoadedInitials = true;
                        vm.toggleSpinner(false);
                        vm.isResetting = false;
                    });
                })
                .catch((error) => {
                    console.log(error);
                    vm.toggleSpinner(false);
                });
        },
        getNextPage() {
            if (!this.isLoading) {
                this.page++;
                // this.getProducts(this.pageSize * (this.page - 1), this.pageSize);
            }
        },
        getInitialProducts() {
            // Get all cases up to, and including, the current page
            // const initialPageSize = this.pageSize * this.page;
            this.getProducts(0, this.page * this.pageSize, true);
        },
        filterChanged(resetPage = false, append = false) {
            this.isResetting = true;
            if (!append || resetPage) {
                this.page = 1;
                this.getProducts(0, this.pageSize, append);
                console.log("hej");
            } else {
                this.getProducts(this.pageSize * (this.page - 1), this.pageSize, append);
                console.log("hejsa");
            }
            // this.products = [];
            // this.totalProducts = 0;
            // this.loadedProducts = 0;
            // this.page = 1;
            // this.getProducts(0, this.pageSize);
        },
        resetFilter() {
            const vm = this;
            vm.isResetting = true;
            vm.products = [];
            vm.totalProducts = 0;
            vm.loadedProducts = 0;
            vm.page = 1;
            if (!vm.hasPreselectedCategory) {
                vm.category = defaultCategory;
            }
            if (!vm.hasPreselectedType) {
                vm.type = defaultType;
            }
            vm.functionality = defaultFunctionality;
            vm.space = defaultSpace;

            vm.$router.replace({ path: window.location.pathname, query: {} })
                .then(() => {
                    vm.getProducts(0, vm.pageSize);
                })
                .catch(err => { console.log(err); });
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            const bodyElement = document.querySelector("body");
            if (isLoading) {
                bodyElement.classList.add("is-loading");
            } else {
                bodyElement.classList.remove("is-loading");
            }
        },
    },
    computed: {
        hasMoreProducts() {
            return (
                this.totalProducts !== 0 &&
                this.products.length < this.totalProducts
            );
        },
        hasFilterApplied() {
            return this.functionality != defaultFunctionality ||
                this.space != defaultSpace ||
                this.category != defaultCategory && !this.hasPreselectedCategory ||
                this.type != defaultType && !this.hasPreselectedType;
        }
    },
};
</script>